import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoofDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home-roof-door, house"} maskId="square-filled-radius-0-stroke-1-IconHomeRoofDoor"><path d="M22.6982 9.64062L22.1094 10.4482L20 8.90918V21H14V14H10V21H4V8.90918L1.89062 10.4482L1.30078 9.64062L12 1.8291L22.6982 9.64062Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHomeRoofDoor;
